import ContentStorage, { ComponentKeys } from '../tnew/content/ContentStorage';
import ControlGroup from './ControlGroup';
import { ControlGroupResultPair } from './types';
import { ValidationResult } from './ValidationService';

export class FormErrorMessageRenderer {
  constructor(private headingLevel: number, private errorHeadingId: string) { }

  renderErrorMessage(pairs: ControlGroupResultPair[]): string | null {
    const errorItemList: string[] = [];

    for (let i = 0; i < pairs.length; i += 1) {
      const errorItem = this.renderErrorItem(pairs[i]);
      if (errorItem !== null) errorItemList.push(errorItem);
    }

    if (errorItemList.length === 0) return null;

    return `
      <h${this.headingLevel} id="${this.errorHeadingId}" class="tn-form-errors-alert__heading sr-only">Form Errors</h${this.headingLevel}>
      <div class="tn-form-errors-alert__message">${this.getUserMessage()}</div>
      <ul aria-labelledby="${this.errorHeadingId}" class="tn-form-errors-alert__list">
        ${errorItemList.join('\n')}
      </ul>
    `;
  }

  private renderErrorItem({ validationResult, controlGroup }: ControlGroupResultPair): string | null {
    if (validationResult.isValid) return null;

    return controlGroup
      ? this.renderErrorForControlGroup(validationResult, controlGroup)
      : this.renderRawValidationError(validationResult);
  }

  private renderRawValidationError(validation: ValidationResult): string {
    const fieldExists = !!document.querySelector(`#${validation.fieldId}`);

    const textContainer = fieldExists
      ? `<a href="#${validation.fieldId}">${validation.message}</a>`
      : `<span>${validation.message}</span>`;

    return `<li>${textContainer}</li>`;
  }

  private renderErrorForControlGroup(validation: ValidationResult, control: ControlGroup): string | null {
    if (!control.isVisible()) return null;

    return `
    <li>
      <a href="#${control.input.elementId}">${control.input.label || control.input.name}: ${validation.message}</a>
    </li>
    `;
  }

  private getUserMessage(): string {
    return ContentStorage.get(ComponentKeys.FORM_FIELDS, 'FormSubmissionErrorMessage');
  }
}
